/**
* @copyright Copyright (C) 2020 Kokoon - All Rights Reserved
* Unauthorized copying of this file, via any medium is strictly prohibited
* Proprietary and confidential
*/

import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Box from '@material-ui/core/Box';
import { METRICS_TYPE } from 'Constants';
import KnMetricsChart from './charts/MetricsChart';
import {
  KnMetricsLabel,
  KnCommonSymptomsWrapper,
  KnSymptomLabel,
  KnSymptomFrequency,
} from './styles';

const KnCommonSymptoms = ({ symptoms }) => {
  const { t: translate } = useTranslation();

  return (
    <KnCommonSymptomsWrapper mb={2}>
      <KnMetricsLabel>{translate('PATIENT_RECORD.symptomMetrics.topSymptomsTitle')}</KnMetricsLabel>
      <Box pt={1} pb={1} display="flex" flexDirection="column">
        {symptoms.map(({ type, list }) => {
          /** If there are no symptoms in a month, value will be null. */
          const count = _.sumBy(list, (item) => (item.value || 0));

          return (
            <Box display="flex" key={type}>
              <KnSymptomLabel>{type}</KnSymptomLabel>
              <KnSymptomFrequency>
                {translate('PATIENT_RECORD.symptomMetrics.symptomFrequency', { count })}
              </KnSymptomFrequency>
            </Box>
          );
        })}
      </Box>
    </KnCommonSymptomsWrapper>
  );
};

const KnSeizureDetails = (props) => {
  const { t: translate } = useTranslation();

  return (
    <>
      <KnMetricsLabel>{translate('PATIENT_RECORD.seizureMetrics.chartTitle')}</KnMetricsLabel>
      <KnMetricsChart {...props} />
    </>
  );
};

const KnSymptomDetails = ({ data, chartId }) => (
  <>
    <KnCommonSymptoms symptoms={data} />
    {data.map((chart) => (
      <Box pb={2} key={`${chartId}-${chart.type}`}>
        {/* TODO: revise this when we have reference data?
            For now use the symtomName value returned by BE. */}
        <KnMetricsLabel>{chart.type}</KnMetricsLabel>
        <KnMetricsChart
          chartId={`${chartId}-${chart.type}`}
          data={chart.list}
        />
      </Box>
    ))}
  </>
);

/**
 * Displays metrics specific UI.
 */
const KnMetricsDetails = ({ type, aggregatedData }) => {
  const isSeizureMetrics = (type === METRICS_TYPE.seizure);
  const chartId = `${type}-chart`;
  const KnMetricsDetailsVariant = isSeizureMetrics ? KnSeizureDetails : KnSymptomDetails;

  return (
    <KnMetricsDetailsVariant
      chartId={chartId}
      data={aggregatedData}
    />
  );
};

KnMetricsDetails.propTypes = {
  type: PropTypes.oneOf([METRICS_TYPE.seizure, METRICS_TYPE.symptom]).isRequired,
  aggregatedData: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

KnSymptomDetails.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  chartId: PropTypes.string.isRequired,
};

KnCommonSymptoms.propTypes = {
  symptoms: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default KnMetricsDetails;
